export default __webpack_public_path__ + "static/media/apple.805d0187.svg";